import { getCookieConsent } from "@/components/CookieBanner";
import { isNative } from "@/lib/appConfig";

const GA_MEASUREMENT_ID = "G-LBEX2BBM46";

let gaLoaded = false;

function injectGtagScript() {
    const script = document.createElement("script");
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
    document.head.appendChild(script);
}

function loadGoogleAnalytics() {
    if (gaLoaded) return;
    gaLoaded = true;
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function gtag() { window.dataLayer.push(arguments); };
    window.gtag("js", new Date());
    window.gtag("config", GA_MEASUREMENT_ID);
    injectGtagScript();
}

// GA only loads once the user has accepted analytics cookies via CookieBanner —
// loading it unconditionally would contradict the banner's own "solo se activan si
// las aceptas" promise. Native apps never show that banner (store privacy labels
// apply instead), so consent is never granted there and GA never loads on native.
/**
 * Envia un evento a GA4. No hace nada si el usuario no acepto la analitica.
 *
 * Existe porque Meta no vera tus UTM: al declarar el conjunto de datos como
 * servicio financiero, Meta restringe los parametros de URL despues del dominio
 * y los parametros personalizados de evento. Meta sirve para optimizar campanas;
 * saber QUE pieza convirtio tiene que salir de GA4, donde los UTM si llegan. Sin
 * estos eventos, los informes de adquisicion salen a cero por muchos UTM que
 * pongas en los enlaces.
 */
export function trackGA(nombre, params) {
    if (!gaLoaded || !window.gtag) return;
    try {
        window.gtag("event", nombre, params || {});
    } catch (_e) {}
}

export function initAnalytics() {
    if (isNative()) return;

    const consent = getCookieConsent();
    if (consent?.analytics) loadGoogleAnalytics();

    window.addEventListener("qc_cookie_consent_change", (e) => {
        if (e.detail?.analytics) loadGoogleAnalytics();
    });
}
